module.exports = __webpack_public_path__ + "img/logo-prioritet_finans.9bf8a4b4.svg";